import * as React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { Upload, UploadField } from '@components/form';
import { Loader } from '@components/loader';

import * as T from '@modules/bicycles/_bicyclesTypes';
import { ImageViewer } from '@components/imageViewer';

const enhance = compose<T.BicyclesFormProps, T.Outter & T.BicyclesFormProps>(
  connect(
    state => ({
      photos: formValueSelector('module-bicycles')(state, 'photos'),
      fileRef: formValueSelector('module-bicycles-photos')(state, 'fileRef')
    }),
    dispatch => {
      return { changeFieldValue: value => dispatch(change('module-bicycles', 'photos', value)) };
    }
  ),
  withState('inProgress', 'setInProgress', false),
  withHandlers({
    onSubmit: ({ changeFieldValue, photos, closeItem }) => formData => {
      const fileRef = get(formData, 'fileRef');
      if (fileRef && !photos.find(o => fileRef === o)) {
        changeFieldValue([...photos, fileRef]);
      }
      closeItem();
    }
  }),
  lifecycle<any, any>({
    componentWillReceiveProps({ fileRef }: any) {
      if (this.props.fileRef !== fileRef) {
        this.props.setInProgress(false);
      }
    },
    componentWillUnmount() {
      this.props.setInProgress(false);
    }
  }),
  withProps(({ initialValues }) => ({ initialValues: { fileRef: initialValues } })),
  reduxForm({
    form: 'module-bicycles-photos'
  })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, fileRef, inProgress, setInProgress }) => (
  <div style={{ maxHeight: '80vh', overflow: 'auto' }}>
    {inProgress && <Loader />}
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Soubor</h4>
              </Col>
              <Col md={8}>
                <UploadField
                  component={Upload}
                  name="fileRef"
                  accept="image/*"
                  onStart={() => setInProgress(true)}
                  onError={() => setInProgress(false)}
                  onAbort={() => setInProgress(false)}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Náhled</h4>
              </Col>
              <Col md={8} style={{ height: 300 }}>
                {fileRef &&
                  fileRef.contentType.includes('image') && (
                    <ImageViewer src={`/metropolis/api/files/${fileRef.id}`} alt="Náhled" />
                  )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button
        type="submit"
        label="Uložit a zavřít"
        primary={true}
        disabled={!fileRef}
        style={{ margin: '16px 0 16px 16px' }}
      />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const BicycleFormPhotos = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/bicycles/BicycleFormPhotos.tsx